import { baseBackend } from "../../../../../api/base/baseUrl";

const URL_COUNTER_DRIVER = "/api/v2/counter";
export const counterDrivers = async () => {
  return await baseBackend.get(`${URL_COUNTER_DRIVER}/driver`, {
    headers: { "Content-Type": "application/json" },
  });
};
